import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'numberTriplesFormat',
    standalone: false
})
export class NumberTriplesFormatPipe implements PipeTransform {
    transform(value: number|string): string {
        if (!value) {
            return '0';
        }

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
}
